import React from 'react';
import DOMPurify from 'dompurify';
import ExternalLinkPage from './ExternalLinkPage';

const SafeExternalLinkPage = props => {
  const url = props.location.query.url;
  const sanitizeUrl = DOMPurify.sanitize(url);
  const xssPatterns = [
    /<script.*?>.*?<\/script>/i,
    /javascript:/i,
    /on\w+=".*?"/i,
    /<img.*?onerror=".*?"/i,
    /<svg.*?on\w+=".*?"/i,
    /<iframe.*?src="javascript:.*?"/i,
    /<form.*?action="javascript:.*?"/i,
    /style=".*?expression\(.*?\)"/i,
    /<.*?alert\(.*?\).*?>/i,
  ];
  const isInvalidUrl = xssPatterns.some(pattern => pattern.test(sanitizeUrl));
  if (isInvalidUrl) {
    console.warn('Blocked XSS attempt:', url);
  }
  return isInvalidUrl ? (
    <div className="error">Invalid URL or unsafe URL provided</div>
  ) : (
    <ExternalLinkPage {...props} />
  );
};

export default SafeExternalLinkPage;
